import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useMatch } from '@leagueplatform/routing';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';

const redirectedBenefitsDetailsRouteMap = new Map([
  [
    '771dad3f2bd2b5837ccede93df321240',
    '/additional-benefits/program-call-member-services',
  ],
  ['48435649444143484600000000000000', '/additional-benefits/program-vidachf'],
  [
    '484353776f72644d736b2d456e726f6c',
    '/additional-benefits/program-swordmsk-enrolled',
  ],
  ['484353776f72644d534b000000000000', '/additional-benefits/program-swordmsk'],
  ['484353776f72644d736b000000000000', '/additional-benefits/program-swordmsk'],
  [
    '484353776f7264426c6f6f6d00000000',
    '/additional-benefits/program-swordbloom',
  ],
  ['4843416d77656c6c0000000000000000', '/additional-benefits/program-amwell'],
  ['351dad3f2bd2b5837ccede93df321240', '/additional-benefits/program-gyant'],
  [
    '4843537072696e674541502d456c6967',
    '/additional-benefits/program-springeap-eligible-with-mwb',
  ],
  [
    '4843537072696e672d456c696769626c',
    '/additional-benefits/program-springhealth-eligible-with-eap',
  ],
  [
    '4843537072696e674865616c74684541',
    '/additional-benefits/program-springhealtheap-eligible',
  ],
  [
    '4843537072696e674865616c74682d45',
    '/additional-benefits/program-springhealth-eligible',
  ],
  ['48434f6e64756f543244000000000000', '/additional-benefits/program-onduot2d'],
  ['48434f6e64756f543144000000000000', '/additional-benefits/program-onduot1d'],
  [
    '471dad3f2bd2b5837ccede93df321240',
    '/coverage-details/medical-default-active',
  ],
  [
    '571dad3f2bd2b5837ccede93df321240',
    '/coverage-details/dental-default-active',
  ],
  ['371dad3f2bd2b5837ccede93df321240', '/coverage-details/drug-default-active'],
  [
    '271dad3f2bd2b5837ccede93df321240',
    '/coverage-details/vision-default-active',
  ],
  ['321dad3f2bd2b5837ccede93df321240', '/additional-benefits/program-carebaby'],
  ['311dad3f2bd2b5837ccede93df321240', '/additional-benefits/program-careblue'],
  [
    '301dad3f2bd2b5837ccede93df321240',
    '/additional-benefits/program-carewellness',
  ],
  [
    '331dad3f2bd2b5837ccede93df321240',
    '/additional-benefits/program-findprovider',
  ],
  [
    '48436d617465726e6974790000000000',
    '/additional-benefits/program-maternity',
  ],
  ['48434669744f6e000000000000000000', '/additional-benefits/program-fiton'],
  ['484357494e0000000000000000000000', '/additional-benefits/program-win'],
  [
    '48434669746e6573732050726f677261',
    '/additional-benefits/program-fitness-program',
  ],
  [
    '48434c61726b57656c6c6e6573730000',
    '/additional-benefits/program-larkwellness',
  ],
  ['48434c61726b48544e00000000000000', '/additional-benefits/program-larkhtn'],
  [
    '4843537072696e674865616c74680000',
    '/additional-benefits/program-springhealth-eligible',
  ],
  [
    '4843626c7565734f6e43616c6c000000',
    '/additional-benefits/program-bluesoncall',
  ],
]);

// A wrapper component that redirects legacy benefits details pages to the new pages
export const BenefitsRedirectContainer = ({
  children,
  redirectOverrides,
}: {
  children: React.JSX.Element;
  redirectOverrides?: Map<string, string>;
}) => {
  const effectiveMap = redirectOverrides
    ? new Map([...redirectedBenefitsDetailsRouteMap, ...redirectOverrides])
    : redirectedBenefitsDetailsRouteMap;

  const benefitsPath = getModulePath(LEAGUE_MODULE_NAMES.benefits);
  const benefitsDetailsMatch = useMatch(`${benefitsPath}/:benefitsId`);
  if (!benefitsDetailsMatch) return children;
  const benefitsId = benefitsDetailsMatch?.params?.benefitsId || '';

  const redirectToBenefitDetails = (id: string) => {
    const redirectedBenefitsDetailsPath = effectiveMap.get(id)!;
    return (
      <Navigate
        to={`${benefitsPath}${redirectedBenefitsDetailsPath}`}
        replace
      />
    );
  };

  // Check for exact match
  if (effectiveMap.has(benefitsId)) return redirectToBenefitDetails(benefitsId);

  // Check for partial match, some legacy details pages can contain appended identifiers
  const matchingKey = Array.from(effectiveMap.keys()).find((key) =>
    benefitsId.startsWith(key),
  );
  if (matchingKey) return redirectToBenefitDetails(matchingKey);

  return children;
};
